import React from "react";
import { Helmet } from "react-helmet";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AirportContextProvider from "./AirportContext";
import ScrollManagement from "./components/ScrollManagement";
import AirportPage from "./pages/AirportPage/AirportPage";
import ContactsPage from "./pages/ContactsPage";
import SelectAirportPage from "./pages/SelectAirportPage/SelectAirportPage";

function App() {
  const { i18n } = useTranslation();
  const lang = i18n.language?.slice(0, 2) || "uz";

  return (
    <AirportContextProvider>
      <Helmet>
        <html lang={lang} />
      </Helmet>
      <ScrollManagement>
        <Router>
          <Switch>
            <Route path="/" exact component={SelectAirportPage} />
            <Route path="/airport/:icao" exact component={AirportPage} />
            <Route path="/contacts" component={ContactsPage} />
          </Switch>
        </Router>
      </ScrollManagement>
    </AirportContextProvider>
  );
}

export default App;
